import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { IChangedCustomElement } from '../html-elements';

@Component({
  selector: 'app-input-html-element',
  templateUrl: './input-html-element.component.html',
  styleUrls: ['./input-html-element.component.scss']
})
export class InputHtmlElementComponent {

  myGroup: FormGroup = new FormGroup({
    customElement: new FormControl(),
  });

  @Input() idx;
  @Input() name;
  @Input() value;

  @Output() changed:EventEmitter<IChangedCustomElement> = new EventEmitter<IChangedCustomElement>();

  ngOnInit(): void {
    this.myGroup.patchValue({customElement:this.value});
  }

  OnChanged($event: any) {
    this.changed.emit({
      idx: this.idx,
      value: $event.currentTarget.value
    })
  }

}
